import { render, staticRenderFns } from "./AllPolicySearch.vue?vue&type=template&id=60889dce&scoped=true&"
import script from "./AllPolicySearch.vue?vue&type=script&lang=ts&"
export * from "./AllPolicySearch.vue?vue&type=script&lang=ts&"
import style0 from "./AllPolicySearch.vue?vue&type=style&index=0&id=60889dce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60889dce",
  null
  
)

export default component.exports